<template>
    <!--begin::Wrapper-->
    <div id='dnn_ctr464_ModuleContent' class='DNNModuleContent ModDNNHTMLC'>
        <div id='dnn_ctr464_HtmlModule_lblContent' class='Normal'>
            <div class='pageBg'>
                <div class='pageBgInner mt-10' data-aos='fade-up'>
                    <div class="container container-small">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card"></div>
                                <div class="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mt-20 mx-auto">
                                    <!--begin::Form-->
                                    <Form
                                            class='form w-100'
                                            id='kt_login_signin_form'
                                            ref="formRef"
                                            @submit='onSubmitLogin'
                                    >
                                        <!--begin::Heading-->
                                        <div class='text-center mb-10'>
                                                    <span class='symbol symbol-70px symbol-circle me-6'>
                                                      <span class='bg-light-danger symbol-label symbol-label'>
                                                        <span class='svg-icon svg-icon-1 svg-icon-danger'>
                                                                <i
                                                                        class='uil uil-user fs-1 text-danger button_icon'></i>
                                                        </span>
                                                      </span>
                                                    </span>
                                            <!--begin::Title-->
                                            <h1 class="text-dark mt-5 mb-3">{{$t('login_p')}}</h1>
                                            <!--end::Title-->

                                            <!--begin::Link-->
                                            <div class='text-gray-400 fw-bold fs-4'>
                                                {{ $t('register_login_p') }}
                                            </div>
                                            <!--end::Link-->
                                        </div>
                                        <!--begin::Heading-->

                                        <div class="fv-row">
                                            <h4 class="text-center text-dark mt-5 mb-3">{{$t('login_by')}}</h4>
                                            <hr style="background: linear-gradient(to left,transparent,#000,transparent)">
                                            <div class="d-none row">
                                                <div class="col-6">

                                                    <!--begin:Option-->
                                                    <label class='d-flex flex-stacks mb-5 justify-content-center  align-items-center cursor-pointer'>
                                                        <!--begin:Input-->
                                                        <span class='form-check form-check-custom form-check-solid'>
                                                <Field
                                                        v-model="login_method"
                                                        class='form-check-input'
                                                        type='radio'
                                                        name='login_method'
                                                        value='email'
                                                />
                                              </span>
                                                        <!--end:Input-->
                                                        <!--begin:Label-->
                                                        <span class='d-flex align-items-center me-2'>

                                    <!--begin::Description-->
                                        <span class='d-flex flex-column'>
                                          <span class='fw-bolder text-gray-800 fs-5'>{{ $t('by_using_email')}}</span>
                                        </span>
                                                            <!--end:Description-->
                                </span>
                                                        <!--end:Label-->

                                                    </label>
                                                </div>
                                                <div class="col-6">

                                                <!--begin:Option-->
                                                <label class='d-flex flex-stacks justify-content-center align-items-center mb-5 cursor-pointer'>
                                                  <!--end:Label-->

                                                  <!--begin:Input-->
                                                  <span class='form-check form-check-custom form-check-solid'>
                                                <Field
                                                  v-model="login_method"
                                                  class='form-check-input'
                                                  type='radio'
                                                  name='login_method'
                                                  value='phone'
                                                  :disabled="true"
                                                />
                                              </span>
                                                  <!--end:Input-->
                                                  <!--begin:Label-->
                                                  <span class='d-flex align-items-center me-2'>

                                    <!--begin::Description-->
                                        <span class='d-flex flex-column'>
                                          <span class='fw-bolder text-gray-800 fs-5'>{{ $t('by_using_phone')}}</span>
                                        </span>
                                                    <!--end:Description-->
                                </span>
                                                </label>
                                              </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">

                                                    <!--begin:Option-->
                                                    <label class='d-flex flex-stacks mb-5 justify-content-center  align-items-center cursor-pointer'>
                                                        <!--begin:Input-->
                                                        <span class='form-check form-check-custom form-check-solid'>
                                                <Field
                                                        v-model="auth_method"
                                                        class='form-check-input'
                                                        type='radio'
                                                        name='auth_method'
                                                        value='egy'
                                                />
                                              </span>
                                                        <!--end:Input-->
                                                        <!--begin:Label-->
                                                        <span class='d-flex align-items-center me-2'>

                                    <!--begin::Description-->
                                        <span class='d-flex flex-column'>
                                          <span class='fw-bolder text-gray-800 fs-5'>{{ $t('auth_method_egy')}}</span>
                                        </span>
                                                            <!--end:Description-->
                                </span>
                                                        <!--end:Label-->

                                                    </label>
                                                </div>
                                                <div class="col-6">

                                                <!--begin:Option-->
                                                <label class='d-flex flex-stacks justify-content-center align-items-center mb-5 cursor-pointer'>
                                                  <!--end:Label-->

                                                  <!--begin:Input-->
                                                  <span class='form-check form-check-custom form-check-solid'>
                                                <Field
                                                  v-model="auth_method"
                                                  class='form-check-input'
                                                  type='radio'
                                                  name='auth_method'
                                                  value='kenia'
                                                />
                                              </span>
                                                  <!--end:Input-->
                                                  <!--begin:Label-->
                                                  <span class='d-flex align-items-center me-2'>

                                    <!--begin::Description-->
                                        <span class='d-flex flex-column'>
                                          <span class='fw-bolder text-gray-800 fs-5'>{{ $t('auth_method_kin')}}</span>
                                        </span>
                                                    <!--end:Description-->
                                </span>
                                                </label>
                                              </div>
                                            </div>
<!--                                          <div class="text-center" v-if="login_method == 'phone'">-->
<!--                                            <div class="btn-group" dir="ltr">-->
<!--                                              <button class="btn btn-outline-danger" type="button"-->
<!--                                                      :class="sendBy == 'whatsapp' ? 'btn-danger' : ''" @click="sendBy = 'whatsapp'">-->
<!--                                                <i class="fab fa-whatsapp"></i> {{$t('whatsapp')}}-->
<!--                                              </button>-->
<!--                                              <button class="btn btn-outline-danger" type="button"-->
<!--                                                      :class="sendBy == 'sms' ? 'btn-danger' : ''" @click="sendBy = 'sms'">-->
<!--                                                <i class="fas fa-mobile"></i> {{$t('sms')}}-->
<!--                                              </button>-->
<!--                                            </div>-->
<!--                                          </div>-->
                                        </div>
                                        <div class='row'>
                                            <div class='col-md-12 mb-5'>
                                                <!--begin::Input group-->
                                                <div class='fv-row mb-2'>
                                                    <!--begin::Label-->
                                                    <label class='form-label fs-6 fw-bolder required text-dark'>{{auth_method == "egy" ? $t('ssn') : $t("username") }}</label>
                                                    <!--end::Label-->

                                                    <!--begin::Input-->
                                                    <Field
                                                            class='form-control form-control-lg form-control-solid'
                                                            type='text'
                                                            v-model='ssn'
                                                            :rules='auth_method == "egy" ? {required:true,numeric:true,min:14,max:14} : {required:true}'
                                                            :label="auth_method == 'egy' ? $t('ssn') : $t('username')"
                                                            name='ssn'
                                                            autocomplete='off'
                                                    />
                                                    <!--end::Input-->
                                                    <div class='fv-plugins-message-container'>
                                                        <div class='fv-help-block'>
                                                            <ErrorMessage name='ssn'/>
                                                            <ErrorMessage name='personalInformation.nationalId'/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Input group-->
                                            </div>
                                            <div class='col-md-12' v-if="login_method == 'phone'">
                                                <div class='fv-row mb-2'>
                                                    <!--begin::Label-->
                                                    <label class='form-label fs-6 fw-bolder required text-dark'>{{
                                                        $t('phone') }}</label>
                                                    <!--end::Label-->

                                                    <!--begin::Input-->
                                                    <Field
                                                            class='form-control form-control-lg form-control-solid'
                                                            type='tel'
                                                            v-model='phone' maxlength='11' @keyup="isCheckedPassword=false;hasPassword=false"
                                                            :rules="{required:true,numeric:true,min:11,max:11,regex:'(010|011|012|015)[0-9]{8}'}"
                                                            :label="$t('phone')"
                                                            name='phone' :disabled="isVerified"
                                                            autocomplete='off'
                                                    />
                                                    <small class="text-success fw-bolder m-0 p-0 fs-6"
                                                           v-if="isVerified">
                                                        <i class="text-success uil fs-3 uil-check-circle"></i>
                                                        {{$t('phone_verified')}}
                                                    </small>
                                                    <!--end::Input-->
                                                    <div class='fv-plugins-message-container'>
                                                        <div class='fv-help-block'>
                                                            <ErrorMessage name='phone'/>
                                                            <ErrorMessage name='personalInformation.countryCode'/>
                                                            <ErrorMessage name='personalInformation.phoneNumber'/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Input group-->
                                            </div>
                                            <div class="fv-row" v-if="login_method == 'email'">
                                                <!--begin::Label-->
                                                <label class="form-label fs-6 fw-bolder required text-dark">{{$t('email')}}</label>
                                                <!--end::Label-->

                                                <!--begin::Input-->
                                                <Field
                                                        class="form-control form-control-lg form-control-solid"
                                                        type="email"
                                                        v-model="email"  @keyup="isCheckedPassword=false;hasPassword=false"
                                                        :rules="{required:true,email:true}"
                                                        :label="$t('email')"
                                                        name="email"
                                                        autocomplete="off"
                                                />
                                                <!--end::Input-->
                                                <div class="fv-plugins-message-container">
                                                    <div class="fv-help-block">
                                                        <ErrorMessage name="email"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="fv-row" v-if="hasPassword">
                                                <!--begin::Label-->
                                                <label class="form-label fs-6 fw-bolder required text-dark">{{$t('password')}}</label>
                                                <!--end::Label-->

                                                <!--begin::Input-->
                                                <Field
                                                        class="form-control form-control-lg form-control-solid"
                                                        type="password"
                                                        v-model="password"
                                                        :rules="{required:true}"
                                                        :label="$t('password')"
                                                        name="password"
                                                        autocomplete="off"
                                                />
                                                <!--end::Input-->
                                                <div class="fv-plugins-message-container">
                                                    <div class="fv-help-block">
                                                        <ErrorMessage name="password"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--end::Input group-->
                                        </div>

                                      <div>
                                        <small>
                                          <a style="font-size: 14px" class="text-primary"
                                             href="javascript:void(0)" @click="$router.push({name:'forget_password'})">{{$t("forget_password")}}</a>
                                        </small>
                                      </div>

                                        <!--begin::Actions-->
                                        <div class='text-center'>

                                            <!--begin::Submit button-->
                                            <button type='submit'
                                                    ref='submitButton'
                                                    id='kt_sign_in_submit'
                                                    class='btn   btn-danger    mt-5'
                                            >
                                                <span class='indicator-label'> {{(!isCheckedPassword && !hasPassword) ? $t('login') : $t('login') }} </span>

                                                <span class='indicator-progress'>
                                    {{ $t('loading') }}
                                    <span
                                            class='spinner-border spinner-border-sm align-middle ms-2'
                                    ></span>
                                  </span>
                                            </button>
                                            <!--end::Submit button-->

                                        </div>
                                        <!--end::Actions-->
                                    </Form>
                                    <!--end::Form-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='cloudsTop'></div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='show_show_modal' tabindex='-1' role='dialog'
         ref="createAppModalRef"
         aria-labelledby='show_users_modalLabel' aria-hidden='true'>
        <div class='modal-dialog' role='document'>
            <div class='modal-content'>
                <div class='modal-body'>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <div>
                                <!--begin::Form-->
                                <Form
                                        ref='formRefOTP'
                                        class="form w-100"
                                        @submit="onSubmitOTP"
                                >
                                    <!--begin::Heading-->
                                    <div class="text-center mb-10">
                                        <div class='w-25 m-auto text-center'>
                                            <div class="m-auto">
                                                <client-only>
                                                    <Vue3Lottie
                                                            animationLink="https://assets2.lottiefiles.com/packages/lf20_NH5JUEJou2.json"
                                                    />
                                                </client-only>
                                            </div>
                                        </div>
                                        <!--begin::Title-->
                                        <h1 class="text-dark mt-5 mb-3">{{$t('otp_p')}}</h1>
                                        <!--end::Title-->

                                        <!--begin::Link-->
                                        <div class="text-gray-800 mt-10 fw-bold fs-6">
                                            {{$t('otp_p_text')}}
                                            <slot v-if="login_method == 'phone'">
                                                {{$t('phone')}}
                                                <b>{{phone}}</b>
                                            </slot>
                                            <slot v-if="login_method == 'email'">
                                                {{$t('email')}}
                                                <b>{{email}}</b>
                                            </slot>
                                        </div>
                                        <!--end::Link-->

                                    </div>
                                    <!--begin::Heading-->

                                    <div class="row">
                                        <div class="col-md-12 justify-content-center" dir="ltr">

                                            <vue3-otp-input
                                                    ref="otpInput"
                                                    class="justify-content-center"
                                                    input-classes="otp-input"
                                                    :conditionalClass="['one', 'two', 'three', 'four']"
                                                    separator=""
                                                    inputType="numeric"
                                                    :num-inputs="6"
                                                    v-model:value="bindValue"
                                                    :should-auto-focus="true"
                                                    @on-complete="handleOnComplete"
                                                    :placeholder="['*', '*', '*', '*', '*', '*']"
                                            />
                                        </div>
                                    </div>


                                    <!--begin::Actions-->
                                    <div class="text-start mt-2">
                                      <div v-if="!isNewUser">

                                        <div>
                                          <label class="form-label fs-6 fw-bolder required text-dark">{{$t('new_password')}}</label>
                                          <Field
                                            class="form-control form-control-lg form-control-solid"
                                            type="password"
                                            v-model="password"
                                            :rules="{required:true,confirmed:'@password_confirmation',regex:'^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$'}"
                                            :label="$t('password')"
                                            name="password"
                                            autocomplete="off"
                                          />
                                          <div class="fv-plugins-message-container">
                                            <div class="fv-help-block">
                                              <ErrorMessage name="password"/>
                                            </div>
                                          </div>
                                        </div>
                                        <div>

                                          <label class="form-label fs-6 fw-bolder required text-dark">{{$t('password_confirmation')}}</label>
                                          <Field
                                            class="form-control form-control-lg form-control-solid"
                                            type="password"
                                            v-model="password_confirmation"
                                            :rules="{required:true,regex:'^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$'}"
                                            :label="$t('password_confirmation')"
                                            name="password_confirmation"
                                            autocomplete="off"
                                          />
                                          <div class="fv-plugins-message-container">
                                            <div class="fv-help-block">
                                              <ErrorMessage name="password_confirmation"/>
                                            </div>
                                          </div>

                                        </div>
                                        <div class="alert alert-warning">
                                          <ul style="font-size: 12px;font-weight: bold">
                                            <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_1')}}</li>
                                            <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_4')}}</li>
                                            <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_2')}}</li>
                                            <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_3')}}</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="text-center mt-2">
                                        <!--begin::Submit button-->
                                        <button
                                                type="submit"
                                                ref="submitButtonOTP"
                                                id="kt_sign_in_submit2"
                                                class="btn btn-lg btn-danger w-100 mb-5"
                                        >
                                            <span class="indicator-label"> {{$t('verify')}} </span>

                                            <span class="indicator-progress">
                                              {{$t('loading')}}
                                              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                        <!--end::Submit button-->


                                    </div>

                                    <div class="row">
                                      <div class="col-md-12 mt-1">
                                        <div class="text-gray-600 mt-10 fw-bold fs-6 text-center">
                                          <div>
                                            {{$t('resend_otp_p')}}

                                            <span v-if="interval != '00:00'" class="text-danger mb-2 fs-4">
                                          {{interval}}
                                      </span>
                                          </div>
                                          <button type="button" @click="resendOTP()"
                                                  v-if="interval == '00:00'"
                                                  class="btn btn-sm btn-dark">
                                            {{$t('resend_otp')}}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <!--end::Actions-->
                                </Form>
                                <!--end::Form-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--end::Wrapper-->
</template>

<script lang='ts'>
  import { defineComponent, ref, reactive, toRefs, inject, unref, onMounted } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import Swal from 'sweetalert2/dist/sweetalert2.min.js';
  import { hideModal } from '@/core/helpers/dom';
  import * as Yup from 'yup';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Modal } from 'bootstrap';
  import VOtpInput from 'vue3-otp-input';
  import AOS from 'aos';
  import StorageService from '@/core/services/StorageService';
  import JwtService from '@/core/services/JwtService';

  export default defineComponent({
    name: 'sign-in',
    components: {
      Field,
      Form,
      flatPickr,
      ErrorMessage,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const store = useStore();
      const router = useRouter();
      const i18n = useI18n();
      const { t } = useI18n();
      let formRef = ref<HTMLElement | null>(null);
      let formRefOTP = ref<HTMLElement | null>(null);
      let createAppModalRef = ref<HTMLElement | null>(null);
      let thisModalObj: any = null;
      let REGISTER_AUTH: any = StorageService.getStorageService('REGISTER_AUTH');

      const submitButton = ref<HTMLElement | null>(null);
      const submitButtonOTP = ref<HTMLElement | null>(null);
      const otpInput = ref<InstanceType<typeof VOtpInput> | null>(null);
      const bindValue = ref('');

      onMounted(() => {
        AOS.init();
        console.log(Modal);
        thisModalObj = new Modal(createAppModalRef.value, { backdrop: 'static', keyboard: false });
        // if (thisModalObj) {
        //   thisModalObj.show();
        // }
        if (JwtService.getToken()) {
          router.push({ name: 'auth_403' });
        }
        if (REGISTER_AUTH) {
          // router.push({name: 'complete_register_page', params: {token: REGISTER_AUTH}});
        }
      });

      const state = reactive({
        login_method: 'email',
        sendBy: 'sms',
        auth_method: 'egy',

        isCheckedPassword: false,
        isNewUser: 0,
        hasPassword: false,
        isVerified: false,
        isRunningOTP: false,
        interval: '02:00',

        ImageModel: null,
        ImageLoaderProgress: 0,
        ImageLoader: false,

        ssn: null,
        phone: null,
        email: null,
        password: null,
        password_confirmation: null,
      });


      //Form submit function
      const onSubmitLogin = (values, form) => {
        if (!form) {
          return;
        }

        const { setErrors } = form;

        if (!state.isCheckedPassword) {
          checkPassword();
          return;
        }

        if (!state.isVerified) {
          sendOTP();
          return;
        }
        //
        // let _REGISTER_AUTH: any = StorageService.getStorageService('REGISTER_AUTH');
        // if (_REGISTER_AUTH) {
        //     router.push({name: 'complete_register_page', params: {token: _REGISTER_AUTH}});
        // }
      };

      const onSubmitOTP = (values, form) => {
        // Clear existing errors

        if (!form) {
          return;
        }

        if (submitButtonOTP.value) {
          // Activate indicator
          submitButtonOTP.value.setAttribute('data-kt-indicator', 'on');
          submitButtonOTP.value.setAttribute('disabled', 'true');
        }

        const { setErrors } = form;

        // Dummy delay
        // Send login request
        let payload = {
          'countryCode': '20',
          'phoneNumber': state.phone,
          'nationalId': state.ssn,
          'email': state.email,
          'login_method': state.login_method,
          'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          'bindValue': bindValue,
          'otpValue': unref(bindValue),
        };
        if (state.password){
          payload['password'] = state.password;
        }
        store
          .dispatch('moduleAuth/checkOTP', payload)
          .then((response) => {
            // state.isVerified = true;

            if (thisModalObj) thisModalObj.hide();
            let data = response.data.data;

            if (data.user) {
              router.push({ name: 'all_programs_page' }).then(() => {
                location.reload();
              });
            } else {
              router.push({ name: 'complete_register_page', params: { token: data.accessToken } }).then(() => {
                location.reload();
              });
            }

            // onSubmitLogin([], unref(formRef));

            //Deactivate indicator
            submitButtonOTP.value?.removeAttribute('data-kt-indicator');
            submitButtonOTP.value?.removeAttribute('disabled');
          })
          .catch((response) => {
            if (!helpers) {
              return;
            }
            helpers.handleResponse(response, t, router, store, { setErrors });
            //Deactivate indicator
            submitButtonOTP.value?.removeAttribute('data-kt-indicator');
            submitButtonOTP.value?.removeAttribute('disabled');
          });

      };

      const sendOTP = () => {
        if (state.isRunningOTP) return;
        if (submitButton.value) {
          // Activate indicator
          submitButton.value.setAttribute('data-kt-indicator', 'on');
          submitButton.value.setAttribute('disabled', 'true');
        }

        if (state.login_method == 'phone') {
          let payload = {
            'countryCode': '20',
            'phoneNumber': state.phone,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          if (state.password){
            payload['password'] = state.password
          }
          if (state.login_method == "phone"){
            payload['sendBy'] = state.sendBy;
          }
          store
            .dispatch('moduleAuth/sendOTP', payload)
            .then((response) => {
              if (response.token){
                setTimeout(()=>{
                  router.push({ name: 'dashboard' }).then(() => {
                    location.reload();
                  });
                },1000)
                return;
              }
              if (thisModalObj) thisModalObj.show();
              startTimer();
              //TODO:: auth auto fill opt
              // fillInput(response.otpValue)
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });
        }
        if (state.login_method == 'email') {

          let payload = {
            'email': state.email,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          if (state.password){
            payload['password'] = state.password
          }
          store
            .dispatch('moduleAuth/sendOTPEmail', payload)
            .then((response) => {
              console.log(response)
              state.isNewUser = response.isNewUser || 0;
              if (response.token){
                setTimeout(()=>{
                  router.push({ name: 'dashboard' }).then(() => {
                    location.reload();
                  });
                },1000)
                return;
              }
              if (thisModalObj) thisModalObj.show();
              startTimer();
              //TODO:: auth auto fill opt
              // fillInput(response.otpValue)
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });
        }

      };

      const checkPassword = () => {
        if (submitButton.value) {
          // Activate indicator
          submitButton.value.setAttribute('data-kt-indicator', 'on');
          submitButton.value.setAttribute('disabled', 'true');
        }

          let payload = {
            'email': state.email,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          store
            .dispatch('moduleAuth/checkPassword', payload)
            .then((response) => {
              state.isCheckedPassword = true;
              state.hasPassword = response.data.data.hasPassword || false;
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              if (!(response.data.data.hasPassword || false)){
                onSubmitLogin([], unref(formRef));
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });

      };

      const handleOnComplete = (value: string) => {
        if (!formRefOTP.value) {
          return;
        }
        if (state.isCheckedPassword && !state.hasPassword){
          return;
        }
        onSubmitOTP([], unref(formRefOTP));
      };
      const fillInput = (value) => {
        otpInput.value?.fillInput(value);
      };

      const resendOTP = () => {
        sendOTP();
      };
      const checkSecond = (sec) => {
        if (sec < 10 && sec >= 0) {
          sec = '0' + sec;
        }
        if (sec < 0) {
          sec = '59';
        }
        return sec;
      };
      const startTimer = () => {
        var presentTime = state.interval;
        var timeArray: any = presentTime.split(/[:]+/);
        var m = timeArray[0];
        var s = checkSecond((timeArray[1] - 1));
        if (s == 59) {
          m = m - 1;
        }
        if ((m + '').length == 1) {
          m = '0' + m;
        }
        if (m < 0) {
          m = '59';
        }
        state.interval = m + ':' + s;
        if (!(m == '00' && s == '00')) {
          setTimeout(startTimer, 1000);
        } else {
          state.isRunningOTP = false;
        }
      };

      return {
        submitButtonOTP,
        onSubmitOTP,
        resendOTP,
        handleOnComplete,
        otpInput, bindValue,
        formRefOTP,

        ...toRefs(state),
        onSubmitLogin, i18n,
        createAppModalRef,
        formRef,
        submitButton,
      };
    },
  });
</script>
<style>

    .otp-input {
        width: 35px;
        height: 35px;
        padding: 0;
        margin: 0 5px;
        font-size: 17px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* Background colour of an input field with value */
    .otp-input.is-complete {
        background-color: #e4e4e4;
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input::placeholder {
        font-size: 15px;
        text-align: center;
        font-weight: 600;
    }
</style>
